import React, {
  Fragment,
  useReducer,
  useEffect,
  useState,
  forwardRef
} from "react";
import DatePicker from "../../components/Datepicker";
import MaterialSelect from "../../components/MaterialSelect";
import api from "../../services/api";
import MaterialTable from "material-table";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import { CsvBuilder } from "filefy";
import * as XLSX from 'xlsx';
import { TableChart, PictureAsPdf } from "@material-ui/icons";
import * as CONSTANTS from "../../services/constants";
import { makeStyles } from "@material-ui/core/styles";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';

const useStyles = makeStyles(theme => ({
  formControl: {
    maxWidth: 230,
    minWidth: 120,
    marginInline: 15
  },
  selectEmpty: {
    // marginTop: theme.spacing(2)
  },
  pdf: {
    marginLeft: "20px",
  },
  groupButtons: {
    display: "flex",
    alignItems: "flex-end",
    marginLeft: "20px"
  }
}));
const initialState = {
  SelectedDocName: "",
  SelectedDocStatus: "",
  SelectedDocType: "",
  SelectedDocSector: "",
  SelectedCompanyStatusId: "",
  year: "",
  month: "",
  cnpj: "",
  socialName: "",
  onlyExpiredDocument: false,
  validityDate: null,
  toValidityDate: null,
  createdAt: null,
  updatedAt: null,
  page: 1
};

function reducer(filter, { field, value }) {
  return {
    ...filter,
    [field]: value
  };
}

const DocumentCompanyReport = () => {
  const [filter, dispatch] = useReducer(reducer, initialState);
  const [dataDocuments, setDocuments] = useState({
    load: true,
    documentTypes: [],
    documentSectors: [],
    documentsAttached: [],
    documentStatuses: [],
    companyStatuses: [],
    columns: [
      { title: "Documento", field: "DocumentName" },
      { title: "Status", field: "AttachmentStatus" },
      { title: "Validade", field: "validityDate" },
      { title: "Data de Envio", field: "createdAt" },
      { title: "Data de aprovação", field: "updatedAt" },
      { title: "Aprovado por", field: "UserApprover" }, 
      { title: "Ref. Mês", field: "month" },
      { title: "Ref. Ano", field: "year" },
      { title: "Empresa", field: "CompanyName" },
      { title: "Status Empresa", field: "CompanyStatus" },
      { title: "Criação Empresa", field: "CompanyCreatedAt" }
    ],
    validityDate: null,
    toValidityDate: null
  });
  const classes = useStyles();

  const onChange = e => {
    const { name, value } = e.target;
    dispatch({ field: name, value: value });
  };

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setDocuments({ ...dataDocuments, load: true });
    const types = "/document-types";
    const status = "/document-status";
    const sectors = "/sectors";
    const validity = dataDocuments.validityDate
      ? dataDocuments.validityDate
      : "";
    const toValidity = dataDocuments.toValidityDate
      ? dataDocuments.toValidityDate
      : "";
    const attachs = `/reports/company/documents?page=${filter.page}&DocumentTypeId=${filter.SelectedDocName}&socialName=${filter.socialName}&cnpj=${filter.cnpj}&AttachmentStatusId=${filter.SelectedDocStatus}&CompanyStatusId=${filter.SelectedCompanyStatusId}&description=${filter.SelectedDocName}&validityDate=${validity}&toValidityDate=${toValidity}&createdAt=${filter.createdAt}&updatedAt=${filter.updatedAt}&year=${year}&month=${month}&sector=${filter.SelectedDocSector}`;
    const companyStatus = "/company-status";

    const requestTypes = await api.get(types);
    const requestStatus = await api.get(status);
    const requestSectors = await api.get(sectors);
    const requestAttachs = await api.get(attachs);
    const requestCompanyStatus = await api.get(companyStatus);

    const formatedAttachs = await formatData(requestAttachs);

    setDocuments({
      ...dataDocuments,
      documentTypes: requestTypes.data.rows,
      documentStatuses: [...requestStatus.data.rows, {id:99, name:"Vencido", description:"Vencido" }],
      documentSectors: requestSectors.data.rows,
      documentsAttached: formatedAttachs,
      companyStatuses: requestCompanyStatus.data.rows,
      load: false
    });
  };

  

  const formatData = async documentsAttached => {
    return await documentsAttached.data.rows.map(item => {

      let expired = (item.validityDate) ? (moment.utc(item.validityDate) < moment()) : false

      if(expired) {
        var statusDoc = 'Vencido';
      } else {
        var statusDoc = item.AttachmentStatus.name ? item.AttachmentStatus.name : "Não definido";
      }

      return {
        DocumentName: item.Document.description
          ? item.Document.description
          : "Não definido",
        AttachmentStatus: statusDoc,
        createdAt: moment.utc(item.createdAt).format("DD/MM/YYYY"),
        updatedAt: moment.utc(item.updatedAt).format("DD/MM/YYYY"),
        validityDate: item.validityDate
          ? moment.utc(item.validityDate).format("DD/MM/YYYY")
          : "Não definido",
        year: item.year ? item.year : "Não informado",
        month: item.month ? item.month : "Não informado",
        CompanyName: item.Company.socialName
          ? item.Company.socialName
          : "Não definido",
        CompanyStatus: item.Company.CompanyStatus.description,
        CompanyCreatedAt: moment
          .utc(item.Company.createdAt)
          .format("DD/MM/YYYY"),
        UserApprover: item.User ? item.User.name : "Não aprovado"
      };
    });
  };

  const setInitialDate = e => {
    setDocuments({ ...dataDocuments, validityDate: e });
  };

  const setFinalDate = e => {
    console.log("TCL: setDate -> e", e);
    setDocuments({ ...dataDocuments, toValidityDate: e });
  };

  const searchAttachs = async () => {
    setDocuments({ ...dataDocuments, load: true });
    const {
      SelectedDocName,
      SelectedDocStatus,
      SelectedDocType,
      SelectedDocSector,
      SelectedCompanyStatusId,
      year,
      month,
      socialName,
      cnpj,
      page,
      validityDate,
      toValidityDate,
      updatedAt,
      createdAt
    } = filter;

    const validity = dataDocuments.validityDate
      ? dataDocuments.validityDate
      : "";
    const toValidity = dataDocuments.toValidityDate
      ? dataDocuments.toValidityDate
      : "";
    const response = await api.get(
      `/reports/company/documents?page=${page}&DocumentTypeId=${SelectedDocType}&socialName=${socialName}&cnpj=${cnpj}&AttachmentStatusId=${SelectedDocStatus}&CompanyStatusId=${SelectedCompanyStatusId}&description=${SelectedDocName}&validityDate=${validity}&toValidityDate=${toValidity}&createdAt=${createdAt}&updatedAt=${updatedAt}&year=${year}&month=${month}&sector=${SelectedDocSector}`
    );

    const formatedAttachs = await formatData(response);

    setDocuments({
      ...dataDocuments,
      documentsAttached: formatedAttachs,
      load: false
    });
  };

  const customPdfButton = () => {
    const title = "DPWCDI Report - Documentos empresas";
    const fileName = `DPWCDI Report Documentos Empresas - ${moment().format(
      "DD/MM/YYYY"
    )}`;

    // Build date range subtitle if dates are provided
    let dateRangeText = "";
    if (dataDocuments.validityDate || dataDocuments.toValidityDate) {
      const startDate = dataDocuments.validityDate ? moment(dataDocuments.validityDate).format("DD/MM/YYYY") : "...";
      const endDate = dataDocuments.toValidityDate ? moment(dataDocuments.toValidityDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    const headers = [
      [
        "Empresa",
        "Documentos",
        "Status",
        "Validade",
        "Data de Envio",
        "Data de aprovação",
        "Ref. Mês",
        "Ref. Ano",
        "Aprovador"
      ]
    ];

    const data = dataDocuments.documentsAttached.map(item => [
      item.CompanyName,
      item.DocumentName,
      item.AttachmentStatus,
      item.validityDate,
      item.createdAt,
      item.updatedAt,
      item.month,
      item.year,
      item.UserApprover
    ]);

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let currentY = 20;

    // Add title
    doc.text(title, marginLeft, currentY);
    currentY += 20;

    // Add date range if provided
    if (dateRangeText) {
      doc.setFontSize(12);
      doc.text(dateRangeText, marginLeft, currentY);
      currentY += 15;
    }

    let content = {
      startY: currentY + 10,
      head: headers,
      body: data
    };

    doc.autoTable(content);
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare headers and data
    const headers = ['Empresa', 'Documento', 'Status', 'Validade', 'Data de Envio', 'Data de Aprovação', 'Ref. Mês', 'Ref. Ano', 'Aprovador', 'Status Empresa', 'Criação Empresa'];
    const data = dataDocuments.documentsAttached.map(item => [
      item.CompanyName,
      item.DocumentName,
      item.AttachmentStatus,
      item.validityDate,
      item.createdAt,
      item.updatedAt,
      item.month,
      item.year,
      item.UserApprover,
      item.CompanyStatus,
      item.CompanyCreatedAt
    ]);

    // Build date range text if dates are provided
    let dateRangeText = "";
    if (dataDocuments.validityDate || dataDocuments.toValidityDate) {
      const startDate = dataDocuments.validityDate ? moment(dataDocuments.validityDate).format("DD/MM/YYYY") : "...";
      const endDate = dataDocuments.toValidityDate ? moment(dataDocuments.toValidityDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    // Create worksheet structure with title and optional date range
    let worksheetData = [
      [], // Empty row
      ['DPWCDI Report - Documentos Empresas'], // Title
      [`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`] // Generation date
    ];

    // Add date range if provided
    if (dateRangeText) {
      worksheetData.push([dateRangeText]);
    }

    // Add empty row and headers
    worksheetData.push([], headers, ...data);

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Calculate merges based on whether date range is included
    const titleRowIndex = 1;
    const dateGenRowIndex = 2;
    const dateRangeRowIndex = dateRangeText ? 3 : -1;
    const headerRowIndex = dateRangeText ? 5 : 4;

    // Merge cells for title, generation date, and optional date range
    ws['!merges'] = [
      { s: { r: titleRowIndex, c: 0 }, e: { r: titleRowIndex, c: 10 } }, // Title spans columns A-K
      { s: { r: dateGenRowIndex, c: 0 }, e: { r: dateGenRowIndex, c: 10 } } // Generation date spans columns A-K
    ];

    // Add date range merge if it exists
    if (dateRangeText) {
      ws['!merges'].push({ s: { r: dateRangeRowIndex, c: 0 }, e: { r: dateRangeRowIndex, c: 10 } });
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 25 },  // Empresa
      { wch: 30 },  // Documento
      { wch: 15 },  // Status
      { wch: 12 },  // Validade
      { wch: 12 },  // Data de Envio
      { wch: 12 },  // Data de Aprovação
      { wch: 10 },  // Ref. Mês
      { wch: 10 },  // Ref. Ano
      { wch: 20 },  // Aprovador
      { wch: 15 },  // Status Empresa
      { wch: 12 }   // Criação Empresa
    ];

    // Style header row with blue background and white text
    headers.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1e88e5' } },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Documentos Empresas');

    // Generate filename with current date
    const fileName = `DPWCDI_Report_Documentos_Empresas_${moment().format('DD-MM-YYYY')}.xlsx`;

    // Save file
    XLSX.writeFile(wb, fileName);
  };

  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <Button
        size="small"
        className={"btn-info"}
        startIcon={<TableChart {...props} ref={ref} color="action" />}
        onClick={exportToExcel}
      >
        XLS
      </Button>
    )),
    DetailPanel: () => null,
    SortArrow: () => null
  };

  const {
    SelectedDocName,
    SelectedDocStatus,
    SelectedDocSector,
    SelectedCompanyStatusId,
    socialName,
    cnpj,
    page,
    validityDate,
    toValidityDate,
    year,
    month,
    updatedAt,
    createdAt
  } = filter;

  return (
    <Fragment>
      <div className="col-md-12">
        {/* Filtros empresa */}
        <h3 className="card-title mt-1">Filtros da empresa</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <TextField
              name="socialName"
              label="Razão Social"
              value={socialName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="cnpj"
              label="CNPJ"
              value={cnpj}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedCompanyStatusId"
              dateLabel="Status"
              value={SelectedCompanyStatusId}
              data={dataDocuments.companyStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-6"></div>
        </div>
        <hr />
        {/* Filtros documentos */}
        <h3 className="card-title mt-4">Filtros dos documentos</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2 ">
            <DatePicker
              name="validityDate"
              data={dataDocuments.validityDate}
              onChange={e => setInitialDate(e)}
              dateLabel="Validade de:"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              name="toValidityDate"
              data={dataDocuments.toValidityDate}
              onChange={e => setFinalDate(e)}
              dateLabel="Validade até:"
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="SelectedDocName"
              label="Nome"
              value={SelectedDocName}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedDocStatus"
              dateLabel="Status"
              value={SelectedDocStatus}
              data={dataDocuments.documentStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedDocSector"
              dateLabel="Área gestora"
              value={SelectedDocSector}
              data={dataDocuments.documentSectors}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2 ">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="month">Mês</InputLabel>
              <Select
                labelId="month"
                name="month"
                value={month}
                onChange={onChange}
              >
                <MenuItem></MenuItem>
                {CONSTANTS.months()
                  ? CONSTANTS.months().map(item => {
                      return (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-2">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="year">Ano</InputLabel>
              <Select
                labelId="year"
                name="year"
                value={year}
                onChange={onChange}
              >
                <MenuItem></MenuItem>
                {CONSTANTS.years()
                  ? CONSTANTS.years().map(item => {
                      return (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3 " className={classes.groupButtons}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={"btn-info"}
              startIcon={<SearchIcon />}
              onClick={searchAttachs}
            >
              Pesquisar
            </Button>
            <Button
              size="small"
              className={"btn-info"}
              startIcon={<PictureAsPdfTwoToneIcon />}
              onClick={customPdfButton}
              className={classes.pdf}
            >
              PDF
            </Button>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12 mt-1">
            <MaterialTable
              title=""
              icons={tableIcons}
              isLoading={dataDocuments.load}
              options={{
                exportButton: true,
                exportAllData: true,
                defaultExpanded: true,
                exportCsv: (columns, renderData) => {
                  // Override default CSV export to use our Excel function
                  exportToExcel();
                }
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  firstTooltip: "Primeira",
                  previousTooltip: "Anterior",
                  nextTooltip: "Próxima",
                  lastTooltip: "Última"
                },
                body: {
                  emptyDataSourceMessage: "Não há dados a serem exibidos"
                },
                header: {
                  actions: "Ações"
                },
                grouping: {
                  groupedBy: "Agrupado por:",
                  placeholder: "Arraste os cabeçalhos aqui para agrupar"
                },
                toolbar: {
                  nRowsSelected: "{0} linha(s) selecionada(s)",
                  searchPlaceholder: "Pesquisar",
                  exportTitle: "Exportar para Excel",
                  exportName: "Exportar para Excel"
                }
              }}
              columns={dataDocuments.columns}
              data={dataDocuments.documentsAttached}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DocumentCompanyReport;
